module.exports = __webpack_public_path__ + "img/example-contest-inscription-qr-code.1a77e06d.png";